/**
 * Labstep
 *
 * @module prosemirror/nodes/experiment-table
 * @desc ExperimentTable node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'experiment_table';

export const NodeExperimentTable: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: { default: null },
      guid: { default: null },
    },
    group: 'block',
    marks: '',
    parseDOM: [{ tag: 'div', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { id, guid } = node.attrs;
      return [
        'div',
        {
          [`data-${key}-id`]: id,
          [`data-${key}-guid`]: guid,
        },
      ];
    },
  },
};
